exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".p-hdg-weng[data-v-bf82faac]{margin-top:0}\n", ""]);
